import Vue from 'vue'

export default {
  getBuilds ({ commit }) {
    return Vue.api.get('engine/builds')
      .then((res) => commit('init', { builds: res.data }))
  },
  restartBuild ({ commit }, data) {
    return Vue.api.put('engine/builds/' + data.id + '/restart', data)
  },
  getBuildLog (context, data) {
    return Vue.api.post('engine/builds/' + data.id + '/log', data)
  }
}
